import { QuestionTopChoices } from '../../../../entities/candidate_experience/QuestionTopChoices';
import { Col, Row } from 'reactstrap';
import {
  TopChoices,
  TopChoicesChartType,
} from '../../shared_panels/TopChoices';
import stylesheetExports from '../../../../stylesheets/export.module.scss';
import React from 'react';
import classNames from 'classnames';
import { REPORTING_SECTION_CLASS } from '../../../../utils/pdfHandler';
import { PageBreak } from '../PageBreak';

interface PropTypes {
  offeredSalary: QuestionTopChoices;
}

export function OfferedSalaryTopChoices(props: PropTypes) {
  if (props.offeredSalary == null) return null;
  if (props.offeredSalary.top_choices.length === 0) return null;

  return (
    <>
      <PageBreak />
      <Row className={classNames(REPORTING_SECTION_CLASS)}>
        <Col xs='12'>
          <TopChoices
            title='Salary Expectation'
            subtitle={props.offeredSalary.question_text}
            topChoices={props.offeredSalary.top_choices}
            fillColor={stylesheetExports.blue500}
            type={TopChoicesChartType.Bar}
          />
        </Col>
      </Row>
    </>
  );
}
